var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookingMessageInactive = function SvgBookingMessageInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D3736",
    fillOpacity: 0.6,
    d: "M15.584 1.833H6.417c-2.53 0-4.583 2.044-4.583 4.565v6.398c0 2.521 2.053 4.565 4.583 4.565h1.375c.247 0 .577.165.733.367L9.9 19.552c.605.807 1.595.807 2.2 0l1.375-1.824a.93.93 0 0 1 .734-.367h1.375c2.53 0 4.583-2.044 4.583-4.565V6.398c0-2.52-2.054-4.565-4.584-4.565M7.334 11a.913.913 0 0 1-.917-.917.92.92 0 0 1 .917-.917.92.92 0 0 1 .916.917.913.913 0 0 1-.917.917M11 11a.913.913 0 0 1-.916-.917.92.92 0 0 1 .916-.917.92.92 0 0 1 .917.917A.913.913 0 0 1 11 11m3.667 0a.913.913 0 0 1-.917-.917.92.92 0 0 1 .917-.917.92.92 0 0 1 .917.917.913.913 0 0 1-.917.917"
  })));
};
export default SvgBookingMessageInactive;